import { BOOKING_STATUS } from "../constants";


export const getBookingStatus = (status) => {
  return (
    BOOKING_STATUS[status] || {
      label: status,
      color: "text-slate-400",
    }
  );
};
